import { VertexData } from "@babylonjs/core";
import { TerrainGridOptions, TerrainGridOptionsBuilder, TerrainNormalizedGridBuilder } from "core/meshes";
import { IsNumber } from "core/types";
import { IsSize } from "core/geometry";
export class ElevationGridFactory {
    buildTopology(options) {
        const o = this._buildTerrainOptions(options);
        const data = new TerrainNormalizedGridBuilder().withOptions(o).build(new VertexData());
        return data;
    }
    _buildTerrainOptions(options) {
        if (options instanceof TerrainGridOptions) {
            return options;
        }
        if (options instanceof TerrainGridOptionsBuilder) {
            return options.build();
        }
        const builder = new TerrainGridOptionsBuilder()
            .withScale(-1, 1)
            .withInvertIndices(true);
        if (IsSize(options)) {
            builder
                .withColumns(options.width + 1)
                .withRows(options.height + 1);
        }
        if (IsNumber(options)) {
            const s = options;
            builder
                .withColumns(s + 1)
                .withRows(s + 1);
        }
        return builder.build();
    }
}
//# sourceMappingURL=map.grid.factory.js.map